import { FONTS, COLORS } from '../../../../../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');

  return {
    instruction: {
      textAlign: 'center',
      fontWeight: 600,
      marginBottom: 30,
    },
    firstRow: {
      [minMd]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    detailsGroupOne: {
      marginBottom: 30,
      [minMd]: {
        marginBottom: 0,
        width: '38%',
      },
    },
    detailsGroupTwo: {
      [minMd]: {
        width: '60%',
      },
    },
    detailsGroupHeading: {
      fontFamily: FONTS.SECONDARY,
      fontWeight: 300,
      textAlign: 'center',
      [minMd]: {
        fontSize: '2.25rem',
        textAlign: 'left',
      },
    },
    detailItemRow: {
      marginBottom: 30,
      [minSm]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    detailItem: {
      width: '100%',
    },
    detailItemHalf: {
      marginBottom: 30,
      [minSm]: {
        marginBottom: 0,
        width: '49%',
      },
    },
    detailItemLabel: {
      textTransform: 'uppercase',
      color: COLORS.GREY_DARKER,
      marginBottom: 5,
      fontWeight: 500,
      fontSize: '0.625rem',
      textAlign: 'center',
      [minMd]: {
        textAlign: 'left',
      },
    },
    detailItemContent: {
      fontWeight: 300,
      textAlign: 'center',
      [minMd]: {
        textAlign: 'left',
      },
    },
    photoUpload: {
      height: '200px',
      width: '200px',
      // backgroundColor: '#f1f1f1',
      borderRadius: '10px',
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      cursor: 'pointer',
      // flexDirection: 'column',
      objectFit: 'contain',
      margin: '0 10px',
    },
    galleryImages: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  };
};

export default styles;
